export default "__VITE_ASSET__006708bb__"